import React, { useState } from 'react'
import styles from './styles.module.scss'
import {Button, Input} from "../../../ui-components";
import {useAppDispatch, useAppSelector} from '../../../core/hooks'
import {cancelDpOfferRequests} from "../../requests/insurance-thunk";
import {cancelCustomerOfferBrigadePopupRequests, cancelCustomerOfferBrigadeRequests, changeCustomerDcErCallStatus} from "../../requests/er-thunk";
const DcFinishSentry = () => {
  const { request} = useAppSelector(state => state.requests)

  const [clickDisabled, setClickDisabled] = useState<boolean>(false)
  const dispatch = useAppDispatch();
  const submit = (): void => {
      setClickDisabled(true)
      // @ts-ignore
    dispatch(changeCustomerDcErCallStatus(12))
      // dispatch(cancelCustomerOfferBrigadeRequests({ item: {request_uuid: request?.uuid, customer_uuid: request?.customer_uuid}})).then(res => setClickDisabled(false));
  }

  return (
    <div id={styles.replaceBrigadeForm}>
      <Button fullWidth
              className={clickDisabled ? 'click-disabled' : ''}
              onClick={submit}
              type={'contained'}>Да</Button>
    </div>
  )
}

export default DcFinishSentry
